module.exports = __webpack_public_path__ + "img/stellarterm.ea94d65a.png";